// extracted by mini-css-extract-plugin
export var attachmentContainer = "_h9-0";
export var fileList = "_h9-2";
export var removeFileButton = "_h9-1";